
import axiosInstance from './axiosInstance';



export type Address = {
  id?: string;
  locationName: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
};

export type Contractor = {
  contractorId?: string;
  name: string;
  contactEmail: string;
  contactNumber: string;
  status: string;
  lastAssignedDate?: string;
  orgId: string;
  createdAt?: string;
  address: Address;
  logo?: string;
  attachments?: string[];
};

export const contractorRepository = {
  getContractors: async (): Promise<Contractor[]> => {
    const { data } = await axiosInstance.get<Contractor[]>('/api/Contractor');
    return data;
  },

  getContractorById: async (id: string): Promise<Contractor> => {
    const { data } = await axiosInstance.get<Contractor>(
      `/api/Contractor/${id}`
    );
    return data;
  },

  addContractor: async (
    contractor: Contractor
  ): Promise<Contractor> => {
    const { data } = await axiosInstance.post<Contractor>(
      '/api/Contractor',
      contractor
    );
    return data;
  },

  updateContractor: async (
    id: string,
    contractor: Contractor
  ): Promise<void> => {
    await axiosInstance.put(`/api/Contractor/${id}`, contractor);
  },

  deleteContractor: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/api/Contractor/${id}`);
  },

  exportContractors: async (
    format: string,
    search?: string
  ): Promise<Blob> => {
    const { data } = await axiosInstance.get(
      '/api/Contractor/export',
      {
        params: {
          format,
          search,
        },
        responseType: 'blob',
      }
    );

    return data;
  },
};